module.exports = __webpack_public_path__ + "img/panelView_blackBg_2_3.5ce8e76d.png";